import { FilterIcon } from "./FilterIcon";

export default FilterIcon;
